import { render, staticRenderFns } from "./selectGoodsMonitor2.vue?vue&type=template&id=e2875fde&scoped=true"
import script from "./selectGoodsMonitor2.vue?vue&type=script&lang=js"
export * from "./selectGoodsMonitor2.vue?vue&type=script&lang=js"
import style0 from "./selectGoodsMonitor2.vue?vue&type=style&index=0&id=e2875fde&prod&lang=scss&scoped=true"
import style1 from "./selectGoodsMonitor2.vue?vue&type=style&index=1&id=e2875fde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2875fde",
  null
  
)

export default component.exports